import { render, staticRenderFns } from "./DiyImg.vue?vue&type=template&id=1553fa59&scoped=true&"
import script from "./DiyImg.vue?vue&type=script&lang=js&"
export * from "./DiyImg.vue?vue&type=script&lang=js&"
import style0 from "./DiyImg.vue?vue&type=style&index=0&id=1553fa59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1553fa59",
  null
  
)

export default component.exports